import React, { Component } from "react";
import { connect } from "react-redux";
import { Grid, Header, Container, Menu, Button, Popup, Image, Divider } from "semantic-ui-react";
import StackedBarChart from "./chart";
import SelectionPane from "./selection-pane";
import TotalTco from "./totalTco";
import Results from "./results";
import VehicleParameters from "./vehicle-parameters";
import LanguageSelector from "./language-selector";
import { resetApp, resetInitialApp } from "../actions/actions-data";
import languages from "../languages.json";

export default connect(
    mapStateToProps,
    { resetApp, resetInitialApp }
)(
    class App extends Component {
        handleReset() {
            this.props.resetApp();
            this.props.resetInitialApp();
        }
        render() {
            const t = languages[this.props.language];

            return (
                <div>
                    <Menu
                        secondary
                        fixed="top"
                        style={{ backgroundColor: "white", borderBottom: "1px solid lightgrey" }}>
                        <Menu.Item name="title">
                            {/* <Image src="/TCO/psa.png" size="tiny" /> */}
                            <Image src="./logo.svg" size="tiny" />
                        </Menu.Item>
                        <Menu.Item>
                            <Header as="h1">{t.title}</Header>
                        </Menu.Item>
                        <Menu.Menu position="right">
                            <Menu.Item name="master_reset">
                                <Button onClick={() => this.handleReset()}>
                                    {t.reset}
                                </Button>
                            </Menu.Item>
                            <Menu.Item name="vehicle_parameters">
                                <Popup
                                    trigger={<Button>{t.vehicle_parameters.title}</Button>}
                                    content={<VehicleParameters />}
                                    on="click"
                                    style={{ minWidth: "350px" }}
                                    hideOnScroll
                                />
                            </Menu.Item>
                            <Menu.Item name="language">
                                <LanguageSelector />
                            </Menu.Item>
                        </Menu.Menu>
                    </Menu>
                    <Container style={{ height: "100%", marginTop: "5em", width: "97%" }}>
                        <Grid columns={2} doubling stackable style={{ height: "100%" }}>
                            <Grid.Row>
                                <Grid.Column width={11} style={{ height: "100%" }}>
                                    <SelectionPane />
                                    <Divider />
                                    <TotalTco />
                                </Grid.Column>
                                <Grid.Column width={5} style={{ height: "100%" }}>
                                        <StackedBarChart />
                                        <Divider />
                                        <Results />
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Container>
                </div>
            );
        }
    }
);

function mapStateToProps(state) {
    return {
        language: state.reducerLanguage,
    };
}



// WEBPACK FOOTER //
// ./src/components/app.js